
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"60","height":"60"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M18.59 50.11H8v8.49h44v-8.49H41.41M15.45 30.05V16.11h29.1v13.94M22.5 15.91v-5.82h15v5.82M25.59 23.22V58.6M34.41 23.22V58.6M30 .6v9.49"}}),_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M41.75 58.6V30.05h6.28v20.06M18.25 58.6V30.05h-6.28v20.06"}})])
          )
        }
      }
    